import React, { } from 'react';
import { Card, Col, Row, } from 'antd';

import warscholarAndroid from '../myContent/WarscholarAndroid.png';
import quogShooterAndroid from '../myContent/QuogShooterAndroid.png';

import '../App.css';




const AndroidGamesPage: React.FC = () => {


    return (
        <div className="App">
            <header className="App-header">

                <a
                    className="App-link"
                    href="/"
                    rel="noopener noreferrer">
                    Go back
                </a>

                This is my Android games page!

                <Card className='width395 marginBig' >
                    <Row>
                        <Col span={24}>
                            <a
                                className="App-link"
                                href="https://play.google.com/store/apps/details?id=com.CogPocketGames.QuogShooter"
                                target="_blank"
                                rel="noopener noreferrer">
                                QuogShooter
                            </a>
                        </Col>
                        <Col span={24}>
                            <img src={quogShooterAndroid} alt="quogShooterAndroid" className='width160' />

                        </Col>
                    </Row>
                </Card>

                <Card className='width395 marginBig' >
                    <Row>
                        <Col span={24}>
                            <a
                                className="App-link"
                                href="https://play.google.com/store/apps/details?id=com.cogpocket.warscholar"
                                target="_blank"
                                rel="noopener noreferrer">
                                Warscholar
                            </a>
                        </Col>
                        <Col span={24}>
                            <img src={warscholarAndroid} alt="warscholarAndroid" className='width160' />

                        </Col>
                    </Row>
                </Card>


            </header>
        </div>
    );
}

export default AndroidGamesPage;
